import {
	TFileId,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ITotalPrice,
	IItemForGetShortDishInfo,
} from 'types';
import {
	ICreateDishErrorResponseData,
	TCreateDishVisibleForm,
	TTypeOfCreateDishModalWindow,
	IIDsShowInComboDishes,
} from './createDishContext';

export enum CreateDishActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	CHANGE_DISH_NAME = 'CHANGE_DISH_NAME',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_CUSTOMER = 'SET_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_RESTAURANTS_FOR_PRICE = 'SET_RESTAURANTS_FOR_PRICE',
	CHANGE_PRICE = 'CHANGE_PRICE',
	ADD_PRICE = 'ADD_PRICE',
	REMOVE_PRICE = 'REMOVE_PRICE',
	SET_RESTAURANT_WITH_TURN_OFF_COMMENT = 'SET_RESTAURANT_WITH_TURN_OFF_COMMENT',
	SET_RESTAURANT_WITH_REQUIRED_COMMENT = 'SET_RESTAURANT_WITH_REQUIRED_COMMENT',
	CHANGE_DISH_DESCRIPTION = 'CHANGE_DISH_DESCRIPTION',
	SET_DISH_IS_DISABLED = 'SET_DISH_IS_DISABLED',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_SUGGESTED_DISH_CATEGORY = 'SET_SUGGESTED_DISH_CATEGORY',
	SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES = 'SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES',
	SET_SUGGESTED_DISH_SUB_CATEGORY = 'SET_SUGGESTED_DISH_SUB_CATEGORY',
	SET_FETCHED_SUGGESTED_DISHES = 'SET_FETCHED_SUGGESTED_DISHES',
	SET_SUGGESTED_DISHES = 'SET_SUGGESTED_DISHES',
	REMOVE_SUGGESTED_DISH = 'REMOVE_SUGGESTED_DISH',
	SET_ADDITIONAL_DISH_CATEGORY = 'SET_ADDITIONAL_DISH_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES = 'SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES',
	SET_ADDITIONAL_DISH_SUB_CATEGORY = 'SET_ADDITIONAL_DISH_SUB_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISHES = 'SET_FETCHED_ADDITIONAL_DISHES',
	SET_ADDITIONAL_DISHES = 'SET_ADDITIONAL_DISHES',
	REMOVE_ADDITIONAL_DISH = 'REMOVE_ADDITIONAL_DISH',
	SET_DISH_MODIFICATION_CATEGORY = 'SET_DISH_MODIFICATION_CATEGORY',
	SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES = 'SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES',
	SET_DISH_MODIFICATION_SUB_CATEGORY = 'SET_DISH_MODIFICATION_SUB_CATEGORY',
	SET_FETCHED_DISH_MODIFICATIONS = 'SET_FETCHED_DISH_MODIFICATIONS',
	SET_DISH_MODIFICATIONS = 'SET_DISH_MODIFICATIONS',
	REMOVE_DISH_MODIFICATION = 'REMOVE_DISH_MODIFICATION',
	SET_IDS_SHOW_IN_COMBO_DISHES = 'SET_IDS_SHOW_IN_COMBO_DISHES',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateDishActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCreateDishVisibleForm;
	};
}

interface ISetFileId {
	type: CreateDishActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface IChangeDishName {
	type: CreateDishActionTypes.CHANGE_DISH_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedCustomers {
	type: CreateDishActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetCustomer {
	type: CreateDishActionTypes.SET_CUSTOMER;
	payload: {
		customer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: CreateDishActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfoWithStatus[];
	};
}

interface ISetRestaurantsForPrice {
	type: CreateDishActionTypes.SET_RESTAURANTS_FOR_PRICE;
	payload: {
		restaurants: string[];
	};
}

interface IChangePrice {
	type: CreateDishActionTypes.CHANGE_PRICE;
	payload: {
		price: string;
	};
}

interface IAddPrice {
	type: CreateDishActionTypes.ADD_PRICE;
	payload: {
		prices: ITotalPrice[];
	};
}

interface IRemovePrice {
	type: CreateDishActionTypes.REMOVE_PRICE;
	payload: {
		updatedTotalPrices: ITotalPrice[];
		updatedRestaurantsForPrices: string[];
		updatedIsDisabledInRestaurants: string[];
		restaurantWithTurnOffComment: string[];
		restaurantWithRequiredComment: string[];
	};
}

interface ISetRestaurantWithTurnOffComment {
	type: CreateDishActionTypes.SET_RESTAURANT_WITH_TURN_OFF_COMMENT;
	payload: {
		restaurantWithTurnOffComment: string[];
	};
}

interface ISetRestaurantWithRequiredComment {
	type: CreateDishActionTypes.SET_RESTAURANT_WITH_REQUIRED_COMMENT;
	payload: {
		restaurantWithRequiredComment: string[];
	};
}

interface IChangeDishDescription {
	type: CreateDishActionTypes.CHANGE_DISH_DESCRIPTION;
	payload: {
		shortDescription: string;
	};
}

interface ISetDishDisabledInRestaurants {
	type: CreateDishActionTypes.SET_DISH_IS_DISABLED;
	payload: {
		restaurants: string[];
	};
}

interface ISetFetchedTranslation {
	type: CreateDishActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: IMenuTranslation[];
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: CreateDishActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: TLanguageIDs | null;
	};
}

interface IChangeTranslation {
	type: CreateDishActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface IChangeActivationSchedule {
	type: CreateDishActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: string;
	};
}

interface IChangeDeactivationSchedule {
	type: CreateDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: string;
	};
}

interface ISetFetchedCategories {
	type: CreateDishActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		categories: IItemForGetShortInfo[];
	};
}

interface ISetSuggestedDishCategory {
	type: CreateDishActionTypes.SET_SUGGESTED_DISH_CATEGORY;
	payload: {
		suggestedDishCategory: Nullable<string>;
	};
}

interface ISetFetchedSuggestedDishSubCategories {
	type: CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES;
	payload: {
		suggestedDishSubCategories: IItemForGetShortInfo[];
	};
}

interface ISetSuggestedDishSubCategory {
	type: CreateDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY;
	payload: {
		suggestedDishSubCategory: Nullable<string>;
	};
}

interface ISetFetchedSuggestedDishes {
	type: CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISHES;
	payload: {
		suggestedDishes: IItemForGetShortDishInfo[];
	};
}

interface ISetSuggestedDishes {
	type: CreateDishActionTypes.SET_SUGGESTED_DISHES;
	payload: {
		suggestedDishes: string[];
	};
}

interface IRemoveSuggestedDish {
	type: CreateDishActionTypes.REMOVE_SUGGESTED_DISH;
	payload: {
		updatedSelectedSuggestedDishes: string[];
	};
}

interface ISetAdditionalDishCategory {
	type: CreateDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY;
	payload: {
		additionalDishCategory: Nullable<string>;
	};
}

interface ISetFetchedAdditionalDishSubCategories {
	type: CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES;
	payload: {
		additionalDishSubCategories: IItemForGetShortInfo[];
	};
}

interface ISetAdditionalDishSubCategory {
	type: CreateDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY;
	payload: {
		additionalDishSubCategory: Nullable<string>;
	};
}

interface ISetFetchedAdditionalDishes {
	type: CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES;
	payload: {
		additionalDishes: IItemForGetShortDishInfo[];
	};
}

interface ISetAdditionalDishes {
	type: CreateDishActionTypes.SET_ADDITIONAL_DISHES;
	payload: {
		additionalDishes: string[];
	};
}

interface IRemoveAdditionalDish {
	type: CreateDishActionTypes.REMOVE_ADDITIONAL_DISH;
	payload: {
		updatedSelectedAdditionalDishes: string[];
	};
}

interface ISetDishModificationCategory {
	type: CreateDishActionTypes.SET_DISH_MODIFICATION_CATEGORY;
	payload: {
		dishModificationCategory: Nullable<string>;
	};
}

interface ISetFetchedDishModificationSubCategories {
	type: CreateDishActionTypes.SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES;
	payload: {
		dishModificationSubCategories: IItemForGetShortInfo[];
	};
}

interface ISetDishModificationSubCategory {
	type: CreateDishActionTypes.SET_DISH_MODIFICATION_SUB_CATEGORY;
	payload: {
		dishModificationSubCategory: Nullable<string>;
	};
}

interface ISetFetchedDishModifications {
	type: CreateDishActionTypes.SET_FETCHED_DISH_MODIFICATIONS;
	payload: {
		dishModifications: IItemForGetShortDishInfo[];
	};
}

interface ISetDishModification {
	type: CreateDishActionTypes.SET_DISH_MODIFICATIONS;
	payload: {
		dishModifications: string[];
	};
}

interface IRemoveDishModification {
	type: CreateDishActionTypes.REMOVE_DISH_MODIFICATION;
	payload: {
		updatedSelectedDishModifications: string[];
		IDsShowInComboDishes: IIDsShowInComboDishes;
	};
}

interface ISetIDsShowInComboDishes {
	type: CreateDishActionTypes.SET_IDS_SHOW_IN_COMBO_DISHES;
	payload: {
		IDsShowInComboDishes: IIDsShowInComboDishes;
	};
}

interface IChangeExternalId {
	type: CreateDishActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: string;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateDishModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: CreateDishActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: ICreateDishErrorResponseData | null;
	};
}

interface IResetSelectedControls {
	type: CreateDishActionTypes.RESET_FIELDS;
}

export type TCreateDishAction =
	| IChangeVisibleForm
	| ISetFileId
	| IChangeDishName
	| ISetFetchedCustomers
	| ISetCustomer
	| ISetFetchedRestaurants
	| ISetRestaurantsForPrice
	| IChangePrice
	| IAddPrice
	| IRemovePrice
	| ISetRestaurantWithTurnOffComment
	| ISetRestaurantWithRequiredComment
	| IChangeDishDescription
	| ISetDishDisabledInRestaurants
	| ISetFetchedTranslation
	| ISetTranslationTab
	| IChangeTranslation
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedCategories
	| ISetSuggestedDishCategory
	| ISetFetchedSuggestedDishSubCategories
	| ISetSuggestedDishSubCategory
	| ISetFetchedSuggestedDishes
	| ISetSuggestedDishes
	| IRemoveSuggestedDish
	| ISetAdditionalDishCategory
	| ISetFetchedAdditionalDishSubCategories
	| ISetAdditionalDishSubCategory
	| ISetFetchedAdditionalDishes
	| ISetAdditionalDishes
	| IRemoveAdditionalDish
	| ISetDishModificationCategory
	| ISetFetchedDishModificationSubCategories
	| ISetDishModificationSubCategory
	| ISetFetchedDishModifications
	| ISetDishModification
	| IRemoveDishModification
	| ISetIDsShowInComboDishes
	| IChangeExternalId
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
